export default defineAppConfig({
  sidebar: {
    onMenusTab: false,
  },
})
